/* global indexUrlOpened updateUrl deleteUrl toggleUrl approvalStatuses pendingStatus cancelledStatus indexUrlApproved */
/* global createPurchaseOrderUrl indexUrlRejected indexUrlCancelled eaEnabled */

import React, { useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import PurchaseRequisitionsIndexTable from './PurchaseRequisitionsIndexTable';

export default function PurchaseRequisitionsIndex(props) {
    const [fetchOpened, setFetchOpened] = useState(false);
    const [fetchApproved, setFetchApproved] = useState(false);
    const [fetchRejected, setFetchRejected] = useState(false);
    const [fetchCancelled, setFetchCancelled] = useState(false);

    const refetchAll = () => {
        setFetchOpened(true);
        setFetchApproved(true);
        setFetchRejected(true);
        setFetchCancelled(true);
    };

    return (
        <div className="tw-space-y-10">
            <PurchaseRequisitionsIndexTable
                heading={$t('Opened Purchase Requisitions')}
                indexUrl={props.indexUrlOpened}
                updateUrl={props.updateUrl}
                deleteUrl={props.deleteUrl}
                toggleUrl={props.toggleUrl}
                approvalStatuses={props.approvalStatuses}
                pendingStatus={props.pendingStatus}
                cancelledStatus={props.cancelledStatus}
                refetch={fetchOpened}
                refetchAllHandler={refetchAll}
                fetchedHandler={setFetchOpened}
                type="opened"
                eaEnabled={props.eaEnabled}
            />

            <PurchaseRequisitionsIndexTable
                heading={$t('Approved Purchase Requisitions')}
                indexUrl={props.indexUrlApproved}
                updateUrl={props.updateUrl}
                deleteUrl={props.deleteUrl}
                createPurchaseOrderUrl={props.createPurchaseOrderUrl}
                approvalStatuses={props.approvalStatuses}
                pendingStatus={props.pendingStatus}
                cancelledStatus={props.cancelledStatus}
                refetch={fetchApproved}
                refetchAllHandler={refetchAll}
                fetchedHandler={setFetchApproved}
                type="approved"
                eaEnabled={props.eaEnabled}
            />

            <PurchaseRequisitionsIndexTable
                heading={$t('Rejected Purchase Requisitions')}
                indexUrl={props.indexUrlRejected}
                updateUrl={props.updateUrl}
                deleteUrl={props.deleteUrl}
                approvalStatuses={props.approvalStatuses}
                pendingStatus={props.pendingStatus}
                cancelledStatus={props.cancelledStatus}
                refetch={fetchRejected}
                refetchAllHandler={refetchAll}
                fetchedHandler={setFetchRejected}
                type="rejected"
                eaEnabled={props.eaEnabled}
            />

            <PurchaseRequisitionsIndexTable
                heading={$t('Cancelled Purchase Requisitions')}
                indexUrl={props.indexUrlCancelled}
                updateUrl={props.updateUrl}
                deleteUrl={props.deleteUrl}
                approvalStatuses={props.approvalStatuses}
                pendingStatus={props.pendingStatus}
                cancelledStatus={props.cancelledStatus}
                refetch={fetchCancelled}
                refetchAllHandler={refetchAll}
                fetchedHandler={setFetchCancelled}
                type="cancelled"
                eaEnabled={props.eaEnabled}
            />
        </div>
    );
}

if (document.getElementById('purchaseRequisitionsIndex')) {
    var root = document.getElementById('purchaseRequisitionsIndex');
    ReactDOM.render(
        <App>
            <PurchaseRequisitionsIndex
                indexUrlOpened={indexUrlOpened}
                updateUrl={updateUrl}
                deleteUrl={deleteUrl}
                toggleUrl={toggleUrl}
                approvalStatuses={approvalStatuses}
                pendingStatus={pendingStatus}
                cancelledStatus={cancelledStatus}
                eaEnabled={eaEnabled}
                indexUrlApproved={indexUrlApproved}
                createPurchaseOrderUrl={createPurchaseOrderUrl}
                indexUrlRejected={indexUrlRejected}
                indexUrlCancelled={indexUrlCancelled}
            />
        </App>,
        root,
    );
}
